// extracted by mini-css-extract-plugin
module.exports = {"title":"PreviewModal_title_2K2vG","canvas":"PreviewModal_canvas_147hr","text":"PreviewModal_text_2QQ48"};